import { get, post } from './Request'

/**
 * Ajoute une visite de l'appli
 */
export const visit = () => get('/analytics/visit')
